import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost/clientbackend/",
  baseURL: "https://triaangle.online/marketing-backend",
});
